<template>
	<div>
		<svg :width="iconSize" :height="iconSize" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M18.75 19.25C20.4759 19.25 21.875 17.8509 21.875 16.125V11.4375C21.875 9.71161 20.4759 8.3125 18.75 8.3125H3.125C1.39911 8.3125 0 9.71161 0 11.4375V16.125C0 17.8509 1.39911 19.25 3.125 19.25H18.75Z"
				:fill="color" 
			/>
			<path
				d="M0 7.94358V3.625C0 1.89911 1.39911 0.5 3.125 0.5H8.72779C9.34939 0.5 9.94553 0.74693 10.3851 1.18647L12.5948 3.39618C12.7413 3.54269 12.94 3.625 13.1472 3.625H18.75C20.4759 3.625 21.875 5.02411 21.875 6.75V7.94358C21.0457 7.20133 19.9506 6.75 18.75 6.75H3.125C1.92445 6.75 0.829307 7.20133 0 7.94358Z"
				:fill="color" 
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgFolder',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null
		}
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		}
	}
};
</script>

<style scoped>

</style>